import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Search } from 'models/index';
import { environment } from 'environments/environment';
import { SearchService } from '../search/search.service';

@Injectable({
  providedIn: 'root',
})
export class NewsFeedService {
  private api: string;
  private httpOptions: any;

  constructor(
    private http: HttpClient,
    private searchService: SearchService
  ) {
    this.api = `${environment.api_url}`;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
  }

  public myNewsFeed(
    projectId: number,
    sort: string,
    filter: Search,
    page,
    size
  ): Observable<any> {
    return this.http.post(
      `${this.api}/project/${projectId}/feed?page=${page}&size=${size}`,
      this.searchService.preProcessFilters(filter),
      this.httpOptions
    );
  }

  public myNewsFeedQuery(projectId: number): Observable<any> {
    return this.http.get(
      `${this.api}/project/${projectId}/feed/query`,
      this.httpOptions
    );
  }

  public myNewsFeedExportToExcel(
    projectId: number,
    filter: Search
  ): Observable<Blob> {
    return this.http.post(
      `${this.api}/project/${projectId}/feed/export`,
      this.searchService.preProcessFilters(filter),
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        responseType: 'blob',
        observe: 'body',
      }
    );
  }

  public myNewsFeedExportToText(
    projectId: number,
    filter: Search
  ): Observable<string> {
    const httpOptionsText = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      responseType: 'text' as 'text',
    };

    return this.http.post(
      `${this.api}/project/${projectId}/feed/dump`,
      this.searchService.preProcessFilters(filter),
      httpOptionsText
    ) as Observable<string>;
  }
}
